import { isDataUrl } from './imageUtils';
import { extractNumber } from './formatters';
import { DEFAULT_BASE_COLOR_HEX, DEFAULT_SHADE_COLOR_HEX } from '../constants/defaults';
import { getPreviewImagePath } from '../constants/paths';

export function getItemName(item) {
  if (item.modelName) {
    return item.modelName;
  }
  if (item.productVariantName) {
    return item.productVariantName;
  }
  if (item.baseName && item.shadeName) {
    return `${item.baseName} \u00d7 ${item.shadeName}`;
  }
  return 'Custom Lamp';
}

export function getItemSpecs(item) {
  if (item.configuration) {
    return {
      baseColor: item.configuration.baseColorName || item.baseColorName || '',
      shadeColor: item.configuration.shadeColorName || item.shadeColorName || '',
    };
  }
  return {
    baseColor: item.baseColorName || '',
    shadeColor: item.shadeColorName || '',
  };
}

export function getModelCode(item) {
  if (item.modelCode) {
    return item.modelCode;
  }
  if (item.productVariantSku) {
    return item.productVariantSku;
  }
  if (item.baseId && item.shadeId) {
    return `B${String(item.baseId).padStart(2, '0')}-S${String(item.shadeId).padStart(2, '0')}`;
  }
  return null;
}

export function getItemPrice(item) {
  return parseFloat(item.price) || parseFloat(item.priceAtAddition) || 0;
}

export function getItemRenderInfo(item) {
  if (isDataUrl(item.previewImage)) {
    return { type: 'image', src: item.previewImage };
  }

  const baseCode = item.baseCode || item.configuration?.baseCode;
  const shadeCode = item.shadeCode || item.configuration?.shadeCode;
  const baseColorHex = item.baseColorHex || item.configuration?.baseColorHex || DEFAULT_BASE_COLOR_HEX;
  const shadeColorHex = item.shadeColorHex || item.configuration?.shadeColorHex || DEFAULT_SHADE_COLOR_HEX;

  if (baseCode && shadeCode) {
    return {
      type: '3d',
      baseNumber: extractNumber(baseCode),
      shadeNumber: extractNumber(shadeCode),
      baseColor: baseColorHex,
      shadeColor: shadeColorHex,
    };
  }

  if (item.isApiItem) {
    return {
      type: 'swatch',
      baseColor: baseColorHex,
      shadeColor: shadeColorHex,
    };
  }

  return { type: 'image', src: item.previewImage || getPreviewImagePath('base', 1) };
}
